import moment from "moment";

// Date-range helpers for list filters whose values come from <input type="date"> (YYYY-MM-DD).

// True when both ends are set and the end date is before the start date. Same-day ranges are valid.
// YYYY-MM-DD strings compare correctly as plain strings.
export const isInvalidDateRange = (from, to) => !!from && !!to && to < from;

// A picked day's first and last instant in the admin's own timezone, as UTC ISO strings ("...Z").
// The API runs in UTC and reads a bare "YYYY-MM-DDT23:59:59" as UTC, which in IST ends the day at
// 05:29:59 the next morning (and starts it at 05:30), so the offset has to be sent explicitly.
const dayStart = (day) =>
  moment(day, "YYYY-MM-DD").startOf("day").toISOString();
const dayEnd = (day) => moment(day, "YYYY-MM-DD").endOf("day").toISOString();

// Builds "&<name>From=...&<name>To=..." for an inclusive whole-day range. An open end is padded
// the same way as the other InCBot date filters (2000-01-01 / 3000-12-31). Returns "" when no end
// is set or the range is invalid, so an invalid range never reaches the API.
export const buildDateRangeQuery = (name, from, to) => {
  if ((!from && !to) || isInvalidDateRange(from, to)) return "";
  const start = from ? dayStart(from) : "2000-01-01T00:00:00";
  const end = to ? dayEnd(to) : "3000-12-31T23:59:59";
  return `&${name}From=${start}&${name}To=${end}`;
};
